import {
    announcementsBottomNewsContainerElement,
    moreBottomAnnouncementsButtonNewsContainerElement,
    newsBottomRowMeldungen,
} from "@modules/global/dom.ts"

import { scrollPageTo } from "@modules/advert-cards/home.ts"

const announcementsStorageKey = "openBottomAnnouncements"

let gutter = 19
if (SiteInfo.isMobileVersion) {
    gutter = 10
}

const calculateAndSetHeights = () => {
    const announcementsSection = announcementsBottomNewsContainerElement()
    if (!announcementsSection) return

    const announcementsContainer = newsBottomRowMeldungen() as HTMLElement
    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title")
    const moreCardsSection = document.querySelector<HTMLDivElement>("#bottom-meldungen .more-content.row.section-1")

    if (!announcementsContainer || !card || !title) return

    const isOpen = sessionStorage.getItem(announcementsStorageKey) === "1"

    announcementsContainer.style.height = "auto"
    const maxHeight = announcementsContainer.offsetHeight
    announcementsContainer.dataset.maxHeight = maxHeight.toString()

    const cardHeight = card.clientHeight
    const titleHeight = title.clientHeight
    let minHeight = cardHeight + cardHeight + titleHeight + gutter

    if (SiteInfo.isMobileVersion) {
        minHeight = 4 * cardHeight + titleHeight + gutter
    }

    if (!moreCardsSection) return

    if (isOpen) {
        announcementsContainer.style.height = `${maxHeight}px`
        announcementsSection.classList.add("more-is-open")
    } else {
        announcementsContainer.style.height = `${minHeight}px`
        announcementsSection.classList.remove("more-is-open")
    }
}

let announcementsTimeout: Timer | number = 0
const setTimeoutForCalculateAndSetHeights = () => {
    clearTimeout(announcementsTimeout)
    announcementsTimeout = setTimeout(calculateAndSetHeights, 50)
}

const showAnnouncements = () => {
    const announcementsSection = announcementsBottomNewsContainerElement()
    if (!announcementsSection) return

    const announcementsContainer = newsBottomRowMeldungen() as HTMLElement
    if (!announcementsContainer) return

    const maxHeight = Number.parseInt(announcementsContainer.dataset.maxHeight ?? "0")
    if (maxHeight === 0) return

    const moreCardsSection = document.querySelector<HTMLDivElement>("#bottom-meldungen .more-content.row.section-1")
    if (!moreCardsSection) return

    announcementsContainer.style.transition = "height 0.5s"
    announcementsContainer.style.height = `${maxHeight}px`
    announcementsSection.classList.add("more-is-open")
    sessionStorage.setItem(announcementsStorageKey, "1")
}

const hideAnnouncements = () => {
    const announcementsSection = announcementsBottomNewsContainerElement()
    if (!announcementsSection) return

    const announcementsContainer = newsBottomRowMeldungen() as HTMLElement
    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title")

    if (!announcementsContainer || !card || !title) return

    const cardHeight = card.clientHeight
    const titleHeight = title.clientHeight

    let minHeight = cardHeight + cardHeight + titleHeight + gutter

    if (SiteInfo.isMobileVersion) {
        minHeight = 4 * cardHeight + titleHeight + gutter
    }

    const moreCardsSection = document.querySelector<HTMLDivElement>("#bottom-meldungen .more-content.row.section-1")
    if (!moreCardsSection) return

    announcementsContainer.style.transition = "height 0.5s"
    announcementsContainer.style.height = `${minHeight}px`
    announcementsSection.classList.remove("more-is-open")
    sessionStorage.setItem(announcementsStorageKey, "0")
    scrollPageTo(announcementsSection)
}

const toggleAnnouncements = (e: Event) => {
    e.preventDefault()
    const announcementsSection = announcementsBottomNewsContainerElement()
    if (!announcementsSection) return

    if (announcementsSection.classList.contains("more-is-open")) {
        hideAnnouncements()
    } else {
        showAnnouncements()
    }
}

export const initBottomAnnouncements = () => {
    const announcementsSection = announcementsBottomNewsContainerElement()
    const announcementsButton = moreBottomAnnouncementsButtonNewsContainerElement()

    if (!announcementsSection || !announcementsButton) {
        return
    }

    const announcementsContainer = newsBottomRowMeldungen() as HTMLElement
    if (!announcementsContainer) return

    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title")

    if (!card || !title) {
        announcementsSection.style.display = "none"
        return
    }

    announcementsContainer.style.overflow = "hidden"

    calculateAndSetHeights()

    announcementsButton.addEventListener("click", toggleAnnouncements)
    window.addEventListener("resize", setTimeoutForCalculateAndSetHeights)
}
